import type { IApiRouteResponse } from 'types/common';
import type { TWishlist } from 'types/wishlist';

interface IResponse extends IApiRouteResponse {
  data: TWishlist[];
}

export const fetchGetAllWishlists = async (): Promise<IResponse> => {
  const response = await fetch('/api/wishlist');
  return response.json();
};

export const fetchGetDefaultWishlist = async (): Promise<TWishlist> => {
  const { success, data: lists } = await fetchGetAllWishlists();

  if (!success || !lists) {
    return null;
  }

  return lists.find(list => list.default) || null;
};
